import { format } from 'sql-formatter'
import { CodeBlock } from './CodeBlock'

interface SqlCodeBlockProps {
  sql: string
  className?: string
}

export function SqlCodeBlock({ sql, className = '' }: SqlCodeBlockProps) {
  let formattedSql
  try {
    formattedSql = format(sql, {
      language: 'postgresql',
      tabWidth: 2,
      keywordCase: 'upper',
      linesBetweenQueries: 2,
    })
  } catch {
    formattedSql = sql
  }

  return (
    <CodeBlock
      code={formattedSql}
      language="sql"
      label="SQL Query"
      className={className}
    />
  )
}
